import Controller from '@ember/controller';
import { action } from '@ember/object';
import { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';

export default class PlanningDashboardRoiController extends Controller {
  @service('roadmap') roadmapService;
  @service datasetFetcher;

  @tracked data = {};

  get roadmap() {
    return this.roadmapService.selected;
  }

  get initiatives() {
    return this.roadmapService.initiatives;
  }

  @action
  loadData() {
    this.datasetFetcher
      .fetchInitiativesDataset(this.roadmap)
      .then((data) => {
        this.data = data;
      })
      .catch((err) => console.log('load data err', err));
  }
}
